"use strict";
module.exports = ['$http', '$filter', 'ngDroUAACommon', function ($http, $filter, ngDroUAACommon) {

        this.findAll = function (usePrefix) {
            ngDroUAACommon.setUsePrefix(usePrefix || true);
            return $http({
                method: 'GET',
                withCredentials: true,
                url: ngDroUAACommon.getUrl('api/company')
            }).then(function (response) {

                // E' necessario il sorting secondo la lunghezza dei path, altrimenti il codice successivo dava errore
                // response.data = $filter('orderBy')(response.data, 'nodePath', false);

                var a = {}, root;
                
                // metto tutti i nodi in un json indicizzati per id
                angular.forEach(response.data, function (node) {
                    a[node.id] = node;
                });

                
                // in ogni nodo vado a pusharci tutti i suoi figli
                angular.forEach(response.data, function (node) {
                    if (!node.parent) {
                        root = node;
                    } else {
                        //console.log(a, node.parent, a[node.parent])
                        if (!a[node.parent].childs) {
                            a[node.parent].childs = [];
                        }
                        a[node.parent].childs.push(node);
                    }
                });

                
                // ricorsivamente mi riscostruisco l'albero con una visita in profondità
                var r = [];
                var deepVisit = function (node) {

                    if (a[node.parent]) {
                        parent = a[node.parent];
                        node.path = parent.path + node.parent;
                        node.fullName = parent.fullName + " • " + node.name;
                        node.depth = a[node.parent].depth + 1;
                    } else {
                        node.path = "/";
                        node.fullName = a[node.id].name;
                        node.depth = 0;
                    }
                    r.push(node);
                    angular.forEach(node.childs, deepVisit);
                };
                deepVisit(root);

                return r;
            });
        };

        this.findAllMySubTree = function (company_id, usePrefix) {            
            return this.findAll(usePrefix)
                    .then(function (data) {
                        return $filter('filter')(data, function (company) {
                            return company.id === company_id || company.nodePath.indexOf('/' + company_id + '/') !== -1;
                        });
                    });
        };

        this.findOne = function (id, usePrefix) {
            ngDroUAACommon.setUsePrefix(usePrefix || true);
            return $http({
                method: 'GET',
                withCredentials: true,
                url: ngDroUAACommon.getUrl('api/company/' + id)
            });
        };

        this.findCompanyFullPath = function (id, usePrefix) {

            function prettyPath(string_arr) {
                var result = '';
                angular.forEach(string_arr, function (s, index) {
                    result = index !== string_arr.length - 1 ? result.concat(s + " • ") : result.concat(s);
                });
                return result;
            }

            return $http.get('api/company/nodePathName/' + id)
                    .then(function (response) {
                        return prettyPath(response.data);
                    });
        };

        this.delete = function (id, usePrefix) {
            ngDroUAACommon.setUsePrefix(usePrefix || true);
            return $http({
                method: 'DELETE',
                url: ngDroUAACommon.getUrl('api/company/' + id),
                withCredentials: true,
            });
        };

        this.save = function (params, usePrefix) {
            ngDroUAACommon.setUsePrefix(usePrefix || true);
            return $http({
                method: 'POST',
                url: ngDroUAACommon.getUrl('api/company'),
                withCredentials: true,
                data: params
            });
        };

        this.update = function (params, usePrefix) {
            ngDroUAACommon.setUsePrefix(usePrefix || true);
            return $http({
                method: 'PUT',
                url: ngDroUAACommon.getUrl('api/company'),
                withCredentials: true,
                data: params
            });
        };

        this.tree = function (usePrefix) {
            ngDroUAACommon.setUsePrefix(usePrefix || true);
            return $http({
                method: 'GET',
                withCredentials: true,
                url: ngDroUAACommon.getUrl('api/company/tree')
            });
        };
        this.leafs = function (id, usePrefix) {
            ngDroUAACommon.setUsePrefix(usePrefix || true);

            return $http({
                method: 'GET',
                withCredentials: true,
                url: ngDroUAACommon.getUrl('api/company/leafs/' + id)
            });
        };


        return {
            findAllMySubTree: this.findAllMySubTree,
            findAll: this.findAll,
            findOne: this.findOne,
            findCompanyFullPath: this.findCompanyFullPath,
            update: this.update,
            delete: this.delete,
            save: this.save,
            tree: this.tree,
            leafs: this.leafs
        };
    }];



//////////////////
// WEBPACK FOOTER
// ./src/modules/ngDro-uaa/services/rest/company.js
// module id = 398
// module chunks = 0